export default {
  apiKey: "AIzaSyCL6_c2DD5D7AYWVeBDr1-SahtdZrA-Bmg",
  authDomain: "conociendo-a-loly.firebaseapp.com",
  databaseURL: "https://conociendo-a-loly.firebaseio.com",
  projectId: "conociendo-a-loly",
  storageBucket: "conociendo-a-loly.appspot.com",
  messagingSenderId: "963932662768",
  appId: "1:963932662768:web:19880e35e53f7770608b35",
  measurementId: "G-NPBBDRPME1",
};
